import { FC } from 'react';

import NavBar from '../../components/NavBar';

import mainLogo1 from './../../img/logo_main_1.png';


import styles from './politik.module.scss'

interface MainProps {
  title?: string;
}




const Politik: FC<MainProps> = ({
  title = "Политика обработки персональных данных"
}) => {

  const politikName = process.env.REACT_APP_POLITIK_NAME
  const mailAddress = process.env.REACT_APP_MAIL_ADDRESS

  const titleM = title;


  return (
    <div className="Main">
      <div className='lat-form'>
        <div className='lat-form__container lat-form__container_shadow'>
          {/* <NavBar /> */}
          <img className="logo" src={mainLogo1} alt='логотип'></img>
          <div className='lat-form__box'>


            <div>
              {titleM}
            </div>

            <div className='politik-container'>
              <div>
                <div>
                  <div className={styles['politik-item']}>
                    <div className={styles['politik-item__title']}>
                      1. Общие положения
                    </div>
                    <div className={styles['politik-item__text']}>
                      <p>1.1. Политика в отношении обработки персональных данных (далее Политика) направлена на защиту прав и свобод физических лиц, персональные данные которых обрабатывает {politikName} (далее Оператор).</p>
                      <p>1.2. Политика разработана в соответствии с п. 2 ч. 1 ст. 18.1 Федерального закона от 27 июля 2006 г. № 152-ФЗ «О персональных данных» (далее ФЗ «О персональных данных»).</p>
                      <p>1.3. Настоящая Политика подлежит публикации на сайте Компании с целью обеспечения неограниченного доступа к документу.</p>
                    </div>
                  </div>
                  <div className={styles['politik-item']}>
                    <div className={styles['politik-item__title']}>
                      2. Сведения об операторе
                    </div>
                    <div className={styles['politik-item__text']}>
                      <p>2.1. Оператор ведет свою деятельность по адресу: {mailAddress}</p>
                    </div>
                  </div>
                  <div className={styles['politik-item']}>
                    <div className={styles['politik-item__title']}>
                      3. Сведения о собираемых данных
                    </div>
                    <div className={styles['politik-item__text']}>
                      <p>3.1. Персональные данные Фамилия, имя, отчество; адрес; номер контактного телефона; адрес электронной почты и другую информацию, содержащуюся в сообщениях, направляемых через формы обратной связи на сайте;</p>
                      <p>3.2. Технические данные, которые автоматически передаются устройством, в том числе технические характеристики устройства, IP-адрес, информация, сохраненная в файлах «cookies», которые были отправлены на Ваше устройство, информация о браузере, дата и время доступа к сайту, адреса запрашиваемых страниц и иная подобная информация;</p>
                      <p>3.3. Иные данные, которые оставляют посетители на сайте.</p>
                    </div>
                  </div>
                  <div className={styles['politik-item']}>
                    <div className={styles['politik-item__title']}>
                      4. Сведения об обработке персональных данных
                    </div>
                    <div className={styles['politik-item__text']}>
                      <p>4.1. Оператор получает персональные данные непосредственно у субъектов персональных данных.</p>
                      <p>4.2. Оператор обрабатывает персональные данные автоматизированным и неавтоматизированным способами.</p>
                      <p>4.3. Действия по обработке персональных данных включают сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (распространение, предоставление, доступ), обезличивание, блокирование, удаление и уничтожение.</p>
                      <p>4.4. Политика обязательна для ознакомления и исполнения руководителями структурных подразделений, работники которых принимают участие в обработке персональных данных.</p>
                    </div>
                  </div>
                  <div className={styles['politik-item']}>
                    <div className={styles['politik-item__title']}>
                      5. Обработка персональных данных клиентов
                    </div>
                    <div className={styles['politik-item__text']}>
                      <p>5.1. Оператор обрабатывает персональные данные клиентов в целях соблюдения норм законодательства РФ, а также с целью:</p>
                      <ul>
                        <li>• информировать о новых товарах, специальных акциях и предложениях;</li>
                        <li>• заключение и исполнение условий договора.</li>
                      </ul>
                      <p>5.2. Оператор обрабатывает персональные данные клиентов с их согласия, предоставляемого клиентами и/или их законными представителями путем совершения конклюдентных действий на настоящем интернет-сайте.</p>
                      <p>5.3. Оператор обрабатывает персональные данные клиентов не дольше, чем того требуют цели обработки персональных данных, если иное не предусмотрено требованиями законодательства РФ.</p>
                    </div>
                  </div>
                  <div className={styles['politik-item']}>
                    <div className={styles['politik-item__title']}>
                      6. Сведения об обеспечении безопасности персональных данных
                    </div>
                    <div className={styles['politik-item__text']}>
                      <p>6.1. Оператор назначает ответственного за организацию обработки персональных данных для выполнения обязанностей, предусмотренных ФЗ «О персональных данных» и принятыми в соответствии с ним нормативными правовыми актами.</p>
                      <p>6.2. Оператор применяет комплекс правовых, организационных и технических мер по обеспечению безопасности персональных данных для обеспечения конфиденциальности персональных данных и их защиты от неправомерных действий.</p>
                    </div>
                  </div>
                  <div className={styles['politik-item']}>
                    <div className={styles['politik-item__title']}>
                      7. Права субъектов персональных данных
                    </div>
                    <div className={styles['politik-item__text']}>
                      <p>7.1. Субъект персональных данных имеет право:</p>
                      <ul>
                        <li>• на получение персональных данных, относящихся к данному субъекту, и информации, касающейся их обработки;</li>
                        <li>• на уточнение, блокирование или уничтожение его персональных данных в случае, если они являются неполными, устаревшими, неточными, незаконно полученными или не являются необходимыми для заявленной цели обработки;</li>
                        <li>• на отзыв данного им согласия на обработку персональных данных;</li>
                        <li>• на защиту своих прав и законных интересов, в том числе на возмещение убытков и компенсацию морального вреда в судебном порядке;</li>
                        <li>• на обжалование действий или бездействия Оператора в уполномоченный орган по защите прав субъектов персональных данных или в судебном порядке.</li>
                      </ul>
                      <p>7.2. Для реализации своих прав и законных интересов субъекты персональных данных имеют право обратиться к Оператору либо направить запрос лично или с помощью представителя. Запрос должен содержать сведения, указанные в ч. 3 ст. 14 ФЗ «О персональных данных».</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
  );
}

export default Politik;
